import { APP_INITIALIZER, EnvironmentProviders, Provider } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';

/** L'intercepteur est enregistré dans app.config (avec celui du spinner) : une seule fois par requête. */
export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        {
            // La session (access token en mémoire) est restaurée avant la première navigation et les guards.
            provide: APP_INITIALIZER,
            useFactory: (authService: AuthService) => () => authService.restoreSession(),
            deps: [AuthService],
            multi: true,
        },
    ];
};
